import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IProductData, enCurrency } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { paymentService } from 'services/PaymentService';
import { currencyService } from 'services/CurrencyService';

interface IState extends IStateBase {
  cart: IProductData;
  currency: enCurrency;
}

export default class FeeSubscription extends BaseComponent<IState> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ currency: null }, currencyService.getCurrency());
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart, currency } = this.state;

    return (
      <span>
        {currency !== enCurrency.BRL ? (
          <span className="chk-installment-fee theme-footer">
            You will be billed &nbsp;
            <CurrencyFormat value={cart.subscription.priceTax} />
            &nbsp;of fee on the subscription every &nbsp;{cart.subscription.frequency}
            &nbsp;
            {paymentService.getNormalizedFrequencyTypeEnUs(cart.subscription.frequencyType, cart.subscription.frequency)}
            {cart.subscription.hasTax ? (
              <span>
                {' '}
                and <CurrencyFormat value={Number(cart.subscription.taxTax.toFixed(2))} /> on membership
              </span>
            ) : null}
          </span>
        ) : null}
      </span>
    );
  }
}
